// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_ocfqE {
  display: flex;
  justify-content: space-between;
}


.title_content_input_GlVtl {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 8px;
}



.content_input_FPKkk {
  display: flex;
  flex-direction: column;
}



.cardTypesContainer_mkMMP {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_Lbr92 {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid #e0e3e6;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #2a2e32;
    -webkit-user-select: none;
            user-select: none;
  }
}

.minusIcon_JUuL5 {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
}


.sectionWrapper_bisTy {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}

.infoContainerWrapper_BPI8c {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  height: 45px;
}

.infoContainer_kqX89 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;

  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }

  span {
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentInput_aamyh {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_uEIKg {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 8px;
}

.cardTypesContainer_mkMMP {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_Lbr92 {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid #e0e3e6;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #2a2e32;
    -webkit-user-select: none;
            user-select: none;
  }
}

.minusIcon_JUuL5 {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
}



.subtitleContentInput_sinqg {
  font-weight: 300;
  font-size: 11;
  color: #18181b;
}

.singlePhoneNumber_IBMoG {
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: space-between;
  color: #666666;
  font-size: 12px;
  font-weight: 500;

  div {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
}

.contentContainer_cWzdl {
  &.active_fpxbA {
    display: block;
  }

  &.disabled_iUFNM {
    display: none;
  }
}

.automateContainer_TDjRe {
  display: flex;
  flex-direction: column;

  .inputContainer_mmhYg {
    position: relative;

    .iconMagic_PVCPg {
      width: 23px;
      height: 22px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: var(--e4fff9-background);
      border: none;
      border-radius: 50%;
      position: absolute;
      bottom: 10px;
      left: -5px;
      padding: 0px;
      svg {
        width: 20px;
        height: 22px;
        fill: var(--_16c098-background);
      }
    }
  }
}

.footer_AhiQB {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  gap: 4px;
  background-color: var(--f5-background);
  box-sizing: border-box;
  padding: 10px 0px;
  position: absolute;
  bottom: 15px;
  border-radius: 10px;
  font-size: 14px;

  @media (width<=528px) {
    & {
      padding: 30px 10px 22px 10px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AutomateCreateIn/AutomateCreateIn.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;;EAEzB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;;EAEV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;;EAEzB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;;AAIA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,kBAAkB;;IAElB;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,oCAAoC;MACpC,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,YAAY;MACZ;QACE,WAAW;QACX,YAAY;QACZ,+BAA+B;MACjC;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;;EAEf;IACE;MACE,4BAA4B;IAC9B;EACF;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n}\n\n\n.title_content_input {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 8px;\n}\n\n\n\n.content_input {\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid #e0e3e6;\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #2a2e32;\n    user-select: none;\n  }\n}\n\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.sectionWrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  height: 45px;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 8px;\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid #e0e3e6;\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #2a2e32;\n    user-select: none;\n  }\n}\n\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n\n.subtitleContentInput {\n  font-weight: 300;\n  font-size: 11;\n  color: #18181b;\n}\n\n.singlePhoneNumber {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  justify-content: space-between;\n  color: #666666;\n  font-size: 12px;\n  font-weight: 500;\n\n  div {\n    cursor: pointer;\n    user-select: none;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n\n  &.disabled {\n    display: none;\n  }\n}\n\n.automateContainer {\n  display: flex;\n  flex-direction: column;\n\n  .inputContainer {\n    position: relative;\n\n    .iconMagic {\n      width: 23px;\n      height: 22px;\n      cursor: pointer;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--e4fff9-background);\n      border: none;\n      border-radius: 50%;\n      position: absolute;\n      bottom: 10px;\n      left: -5px;\n      padding: 0px;\n      svg {\n        width: 20px;\n        height: 22px;\n        fill: var(--_16c098-background);\n      }\n    }\n  }\n}\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 500px;\n  gap: 4px;\n  background-color: var(--f5-background);\n  box-sizing: border-box;\n  padding: 10px 0px;\n  position: absolute;\n  bottom: 15px;\n  border-radius: 10px;\n  font-size: 14px;\n\n  @media (width<=528px) {\n    & {\n      padding: 30px 10px 22px 10px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_ocfqE`,
	"title_content_input": `title_content_input_GlVtl`,
	"content_input": `content_input_FPKkk`,
	"cardTypesContainer": `cardTypesContainer_mkMMP`,
	"singleTypeCard": `singleTypeCard_Lbr92`,
	"minusIcon": `minusIcon_JUuL5`,
	"sectionWrapper": `sectionWrapper_bisTy`,
	"infoContainerWrapper": `infoContainerWrapper_BPI8c`,
	"infoContainer": `infoContainer_kqX89`,
	"contentInput": `contentInput_aamyh`,
	"titleContentInput": `titleContentInput_uEIKg`,
	"subtitleContentInput": `subtitleContentInput_sinqg`,
	"singlePhoneNumber": `singlePhoneNumber_IBMoG`,
	"contentContainer": `contentContainer_cWzdl`,
	"active": `active_fpxbA`,
	"disabled": `disabled_iUFNM`,
	"automateContainer": `automateContainer_TDjRe`,
	"inputContainer": `inputContainer_mmhYg`,
	"iconMagic": `iconMagic_PVCPg`,
	"footer": `footer_AhiQB`
};
export default ___CSS_LOADER_EXPORT___;
